/**
 * OCR老流程，拍摄识别相关埋点
 * wiki: http://wiki.hellobike.com/pages/viewpage.action?pageId=386402336
 * */

/** 臻有钱_身份认证_老流程页面 曝光 */
export const TE_OCR_ENTER_OLD = 'finance_loan_ocr_identify_old';

/** 臻有钱_身份认证_人像面模块 点击 */
export const TC_OCR_FACE = 'finance_loan_ocr_identify_face';
/** 臻有钱_身份认证_国徽面模块 点击 */
export const TC_OCR_NATIONAL_EMBLEM = 'finance_loan_ocr_identify_nationalEmblem';
/** 臻有钱_身份认证_身份证tab切换 点击 */
export const TC_OCR_TAB = 'finance_loan_ocr_identify_clkTab';
/** 臻有钱_身份认证_双面识别成功_下一步按钮 点击 */
export const TC_OCR_BUTTON_NEXT = 'finance_IdentitySubmit';

/** 臻有钱_身份认证_双面识别成功 曝光 */
export const TE_OCR_BOTH_SUCCEED = 'finance_loan_ocr_identify_succeed';

/** 臻有钱_身份认证_失败弹窗 点击/曝光 */
export const TQ_OCR_FAIL_POPUP = 'finance_loan_ocr_identify_failPopup';
